export const recursivelyAddTelemetry = r => {
  // ignore MFE root paths
  if (r.path?.endsWith('*')) return r

  // For merchant app routes add telemetry
  if (r.name) {
    r.meta = r.meta || {}
    r.meta.telemetry = {
      name: r.name
    }
    r.children?.map(recursivelyAddTelemetry)
  }
  return r
}
